module.exports = __webpack_public_path__ + "static/media/menta-main.bca7ebd6.png";